import { Stack, Typography } from '@mui/material';
import { CreateButton } from 'react-admin';
import useAppBarHeight from '@/components/misc/useAppBarHeight';

export const QuoteEmpty = () => {
    const appbarHeight = useAppBarHeight();
    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            gap={3}
            sx={{
                height: `calc(100dvh - ${appbarHeight}px)`,
            }}
        >
            <img src="./img/empty.svg" alt="No Quotes found" />
            <Stack gap={0} alignItems="center">
                <Typography variant="h6" fontWeight="bold">
                    No quote job folders yet
                </Typography>
                <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                    gutterBottom
                >
                    Create a quote to start a new job folder.
                </Typography>
            </Stack>
            <Stack spacing={2} direction="row">
                <CreateButton resource="quotes" variant="contained" label="New Quote" />
                {/* <QuoteImportButton /> */}
            </Stack>
        </Stack>
    );
};
